export default "__VITE_ASSET__Yg2aPkDD__"